import React from "react";
import {Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import * as AuthorizationInternalFragment from './AuthzInternalFragmentComponent';
import * as CustomStyles from '../../styles/CustomStyles';
import {formatAuthzInternalDates} from './AuthzHelper';
import * as ReminderGenInternal from '../../../utils/calculators/ReminderGeneratorInternal';


const AuthorizationInternalNew = (props) => {
    console.log('AuthorizationInternalNew Component___');

    const methods = useForm({
        defaultValues: {
            lAuthorization: { autorizatie: {employeeId: props.employee.id, workSiteId: props.employee.employmentDetails.workSiteId} },
        } 
    });
    const handleSubmit = methods.handleSubmit;


    const handleSubmitAuthzCreate = (data, event) => {
        event.preventDefault();
        const authorization = data.lAuthorization;
        formatAuthzInternalDates(authorization);
        const reminder = ReminderGenInternal.generateReminder(authorization, props.employer.preference);
        if(reminder) {
            authorization.reminder = ReminderGenInternal.getAuthzReminder(reminder);
            reminder.extra = ReminderGenInternal.getReminderExtra(props.employee, props.employer, props.worksite);
        }
        else {
            authorization.reminder = {};
        }
        props.createAuthorization(authorization, reminder);
    }

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/${props.employee.id}`}>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName}</Link>
                        <Typography color="text.primary">
                            Autorizatie Interna noua
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - Adauga autorizatie Interna</h3>
                </Box>
                <hr/>

                <FormProvider {...methods} > 
                <form id='aaInternalConstructionForm' onSubmit={handleSubmit(handleSubmitAuthzCreate)}>

                    <AuthorizationInternalFragment.AuthorizationInternal 
                        rsvtiOperators={props.rsvtiOperators}
                    />

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>
                    </Grid>

                </form>
                </FormProvider>

            </Stack>
        </Box>
        </Container>
    );

}

export default AuthorizationInternalNew